import { ReactComponent as CheckboxSVG } from "./svg/icon_checkbox.svg";
import { ReactComponent as CheckboxOutlinedSVG } from "./svg/icon_checkbox_outlined.svg";
import "./IconCheckBox.scss";

interface IconCheckBoxProps extends React.ComponentProps<"img"> {
  color?: "green" | "gray" | "black" | "blue";
  id?: string;
  withStroke?: boolean;
  variant?: "filled" | "outlined";
  size?: "sm" | "md";
}

export const IconCheckBox = ({ color = "black", id = "", variant = "filled", size = "sm" }: IconCheckBoxProps) => {
  const className = `icon-checkbox--${color}${variant === "outlined" ? "--outlined" : ""}`;
  const sizeClass = size === "md" ? "icon-checkbox--md" : "";

  return (
    <span id={id} className={`icon-checkbox ${className}${sizeClass ? ` ${sizeClass}` : ""}`}>
      {variant === "outlined" ? <CheckboxOutlinedSVG /> : <CheckboxSVG />}
    </span>
  );
};
